import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ppl-box-section',
    templateUrl: './box-section.component.html',
    styleUrls: ['./box-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BoxSectionComponent {

  @Input() title: string;
  @Input() titleIcon: string;

  constructor() { }

}
